import { render } from "./textSelection.vue?vue&type=template&id=026a49ee&scoped=true"
import script from "./textSelection.vue?vue&type=script&lang=js"
export * from "./textSelection.vue?vue&type=script&lang=js"

import "./textSelection.vue?vue&type=style&index=0&id=026a49ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026a49ee"]])

export default __exports__